import { Linkedin, ArrowUpRight } from 'lucide-react';
import { LINKEDIN_POSTS_URL } from '@/data/jobs';
import { SectionHeader } from '@/components/home/CoreSections';

const COPY = {
  en: { eyebrow: "Latest from LinkedIn", title: "News from Eurogulf Mobility Group", follow: "Follow on LinkedIn", read: "Read on LinkedIn" },
  ar: { eyebrow: "آخر المستجدات على لينكدإن", title: "أخبار مجموعة يوروجلف للتنقل", follow: "تابعونا على لينكدإن", read: "اقرأ على لينكدإن" },
};

export function LinkedInFeed({ posts, lang = 'en', title, eyebrow, className = "bg-[#FAFAFA]", testId = "linkedin-feed" }) {
  const c = COPY[lang];
  return (
    <section data-testid={testId} className={`${className} py-14 sm:py-20 border-t border-black/5`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader compact chip={eyebrow || c.eyebrow} title={title || c.title} align="center" />
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px overflow-hidden rounded-xl border border-black/[0.06] bg-black/[0.06]">
          {posts.map((p) => (
            <a key={p.id} href={p.url} target="_blank" rel="noopener noreferrer" data-testid={`linkedin-post-${p.id}`} className="group flex flex-col bg-white p-6 transition-colors hover:bg-[#FFF4ED]/70">
              <div className="flex items-center justify-between mb-4">
                <span className="font-heading font-bold text-[11px] tracking-wider uppercase text-[#EE5A01]">{p.tag[lang]}</span>
                <Linkedin className="w-4 h-4 text-[#0A66C2]" />
              </div>
              <h3 className="font-heading font-bold text-base text-[#121212] mb-2 leading-snug group-hover:text-[#EE5A01] transition-colors">{p[lang].title}</h3>
              <p className="font-body text-sm text-[#666666] leading-relaxed flex-1">{p[lang].text}</p>
              <span className="inline-flex items-center gap-1 mt-4 font-heading font-bold text-xs text-[#EE5A01]">{c.read} <ArrowUpRight className="w-3 h-3 rtl:-scale-x-100" /></span>
            </a>
          ))}
        </div>
        <div className="text-center mt-8">
          <a href={LINKEDIN_POSTS_URL} target="_blank" rel="noopener noreferrer" className="btn-outline"><Linkedin className="w-4 h-4" /> {c.follow}</a>
        </div>
      </div>
    </section>
  );
}
